var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "castle-escape"
  }, [_c('div', {
    staticClass: "text-section"
  }, [_c('div', {
    staticClass: "text-section-title"
  }, [_vm._v("Castle Escape")]), _vm._v(" "), _c('div', {
    staticClass: "text-section-content"
  }, [_vm._v("\n        I wrote my first small open source "), _c('strong', [_vm._v("text-based adventure-puzzle game")]), _vm._v(" in C++ called "), _c('a', {
    attrs: {
      "href": "https://github.com/grabartley/castle-escape",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Castle Escape")]), _vm._v("!\n        This was written in my spare time after my second year of B.Sc. study and I have since re-written the game in Java.\n        Both versions are played on the terminal.\n        The "), _c('a', {
    attrs: {
      "href": "https://github.com/grabartley/castle-escape-java",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Java version")]), _vm._v(" is "), _c('strong', [_vm._v("available below")]), _vm._v(" for Windows and the source code for both can be found on my GitHub profile.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('img', {
    attrs: {
      "src": require("../assets/castle-escape-logo.png"),
      "alt": "The icon for Castle Escape"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("\"The game begins in the old sewers of a castle and takes you on a journey through the castle's many twists and turns\n        as you search for a way out while learning more and more about your surroundings.\n        You can collect useful items along the way which may help you to escape and uncover more of the castle.\"")]), _vm._v(" "), _c('br'), _c('br'), _c('strong', [_vm._v("- Castle Escape's description")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-links"
  }, [_c('a', {
    attrs: {
      "title": "Download Castle Escape Java for Windows",
      "href": "https://github.com/grabartley/castle-escape-java/releases/download/v1.0.0/Castle.Escape-1.0.0.msi",
      "download": "",
      "rel": "noreferrer nofollow"
    }
  }, [_c('img', {
    staticClass: "link-bubble",
    attrs: {
      "src": require("../assets/windows-10-logo.png")
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-540065f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CastleEscape.vue
// module id = D3w7
// module chunks = 0